import { useState } from 'react';
import { APP_MANAGED_ROUTES } from 'common/app-managed-routes';
import { LandingPage } from '@leagueplatform/solutions-foundation';
import { useIntl } from '@leagueplatform/locales';
import { GenericErrorScreen } from '@ptth-web/shared-module';
import ErrorIllustration from 'assets/error-illustration.svg';
import LogoImage from 'assets/ptth-logo.svg';
import { useNavigate } from 'react-router-dom';
import { SignInFooter } from './sign-in-footer.component';

export const PreLoginLandingPage = () => {
  const { formatMessage } = useIntl();
  const navigate = useNavigate();
  const [hasError, setHasError] = useState(false);

  if (hasError) {
    return (
      <GenericErrorScreen
        illustration={ErrorIllustration}
        description={formatMessage(
          { id: 'STR_LOGIN_ERROR_MESSAGE' },
          { appName: formatMessage({ id: 'STR_APP_NAME' }) },
        )}
        buttonText={formatMessage({ id: 'STR_LOGIN_ERROR_CTA' })}
        onButtonClick={() => {
          setHasError(false);
          navigate(APP_MANAGED_ROUTES.LANDING_PAGE, { replace: true });
        }}
      />
    );
  }

  return (
    <LandingPage
      logo={{
        src: LogoImage,
        alt: formatMessage({ id: 'STR_APP_NAME' }),
      }}
      primaryButton={{
        buttonText: formatMessage({ id: 'STR_LOG_IN' }),
        onClick: () => navigate(APP_MANAGED_ROUTES.SIGN_IN),
        css: {
          width: '327px',
          maxWidth: '327px',
        },
      }}
      secondaryButtons={[
        {
          buttonText: formatMessage({ id: 'STR_CREATE_ACCOUNT' }),
          onClick: () => navigate(APP_MANAGED_ROUTES.SIGN_UP),
          css: {
            width: '327px',
            maxWidth: '327px',
          },
        },
      ]}
      onAuthenticated={(appState) =>
        navigate(appState?.redirectPath || APP_MANAGED_ROUTES.HOME)
      }
      onAuthError={() => setHasError(true)}
      signInFooter={<SignInFooter />}
    />
  );
};
